import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m2.688 10.842a1 1 0 0 0 0-1.684l-3.898-2.5a1 1 0 0 0-1.54.841v5.002a1 1 0 0 0 1.54.841z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c = { render: t };
export {
  c as default,
  t as render
};
//# sourceMappingURL=ic_play_filled-BWL9GcmT.js.map
